import React, { PureComponent, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Root } from './Layout.css';
import { AppBar, Toolbar, ListItem, ListItemText, ListItemIcon, Drawer, List, IconButton, Badge, Menu, MenuItem, Collapse } from '@material-ui/core';
import 'pace-progressbar';
import 'pace-progressbar/themes/blue/pace-theme-minimal.css';
import { globalData, isRole, ROLES } from '../../common/common'
import PermIdentity from '@material-ui/icons/PermIdentity';
import Apps from '@material-ui/icons/Apps';
import DeviceHub from '@material-ui/icons/DeviceHub';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MonetizationOnOutlined from '@material-ui/icons/MonetizationOnOutlined';
import DynamicFeed from '@material-ui/icons/DynamicFeed';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import GroupOutlined from '@material-ui/icons/GroupOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Create from '@material-ui/icons/Create';
import CenterFocusStrong from '@material-ui/icons/CenterFocusStrong';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import Department from '../Department/Department';
import MyProfile from '../MyProfile/MyProfile';
import User from '../User/User';
import Team from '../Team/Team';
import Settings from '../Settings/Settings';
import DeptTeam from '../DeptTeam/DeptTeam';
import LeaderTeam from '../LeaderTeam/LeaderTeam';
import AddClient from '../AddClient/AddClient';
import Clientlist from '../Clientlist/Clientlist';
import Processinglist from '../Processinglist/Processinglist';
import Case from '../Case/Case';
import Matter from '../Matter/Matter';
import AlertDialog from '../Layout/components/AlertDialog';
import LetterAvatar from '../Components/LetterAvatar';
import Timesheet from '../Timesheet/Timesheet';
import InvoiceAdvanceInfo from '../InvoiceAdvanceInfo/InvoiceAdvanceInfo';
import InvoiceNormalInfo from '../InvoiceNormalInfo/InvoiceNormalInfo';
import MatterList from '../MatterList/MatterList';
import InvoiceCreate from '../InvoiceCreate/InvoiceCreate';
import Dashboard from '../Dashboard/Dashboard';
import StaffTeam from '../StaffTeam/StaffTeam';
import CaseBalance from '../CaseBalance/CaseBalance';
import CaseInvoice from '../CaseInvoice/CaseInvoice';
import SmartTools from '../SmartTools/SmartTools';
import ToolEstate from '../ToolEstate/ToolEstate';
import InvoiceList from '../InvoiceList/InvoiceList';
import ReferralList from '../ReferralList/ReferralList';
import ReferralEdit from '../ReferralEdit/ReferralEdit';
import ToolTrademark from '../ToolTrademark/ToolTrademark';
import userDao from '../../request/userDao';
import Revenue from '../Revenue/Revenue';
import ConflictStandardTask from '../ConflictStandardTask/ConflictStandardTask';
import ConflictTask from '../ConflictTask/ConflictTask';
import ConflictTaskInfo from '../ConflictTaskInfo/ConflictTaskInfo';
import ConflictReport from '../ConflictReport/ConflictReport';
import ConflictReportInfo from '../ConflictReportInfo/ConflictReportInfo';

let prevItem = 0;
class Layout extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            openItem: 0,
            menuId: "menu-appbar",
            auth: true,
            anchorEl: null,
            open: false,
            open_link: true,
            selectedIndex: 1,
            username: "",
            navData: [],
            showAlert: false,
            userInfo: "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleMenu = this.handleMenu.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleMyProfile = this.handleMyProfile.bind(this);
        this.handleListItemClick = this.handleListItemClick.bind(this);
        this.handleSettings = this.handleSettings.bind(this);
        this.handleSingOut = this.handleSingOut.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleOpenItemClick = this.handleOpenItemClick.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }
    render() {
        // const {show} = this.props;
        const {
            openItem,
            selectedIndex,
            menuId,
            anchorEl,
            open,
            showAlert,
            navData,
            userInfo,
        } = this.state;
        const icons = (index) => {
            if (index === 0) {
                return <Apps />
            } else if (index === 1) {
                return <DeviceHub />
            } else if (index === 2) {
                return <PermIdentity />
            } else if (index === 3) {
                return <GroupOutlined />
            } else if (index === 4) {
                return <DescriptionOutlinedIcon />
            } else if (index === 5) {
                return <Create />
            } else if (index === 6) {
                return <AccessTimeIcon />
            } else if (index === 7) {
                return <MonetizationOnOutlined />
            } else if (index === 8) {
                return <CenterFocusStrong />
            } else if (index === 9) {
                return <ErrorOutline />
            } else if (index === 10) {
                return <DynamicFeed />
            }
        }
        const currentPage = () => {
            let pathName = this.props.location.pathname;
            let pathArr = pathName.split("/");
            let currentPath = pathArr[2];
            if (currentPath === "department") {
                return <Department></Department>
            } else if (currentPath === "myprofile") {
                return <MyProfile></MyProfile>
            } else if (currentPath === "user") {
                return <User></User>
            } else if (currentPath === "team") {
                return <Team></Team>
            } else if (currentPath === "settings") {
                return <Settings></Settings>
            } else if (currentPath === "deptTeam") {
                return <DeptTeam></DeptTeam>
            } else if (currentPath === "leaderteam") {
                return <LeaderTeam></LeaderTeam>
            } else if (currentPath === "staffteam") {
                return <StaffTeam></StaffTeam>
            } else if (currentPath === "addclient") {
                return <AddClient></AddClient>
            } else if (currentPath === "clientlist") {
                return <Clientlist></Clientlist>
            } else if (currentPath === "processinglist") {
                return <Processinglist></Processinglist>
            } else if (currentPath === "case") {
                return <Case></Case>
            } else if (currentPath === "matter") {
                return <Matter></Matter>
            } else if (currentPath === "timesheet") {
                return <Timesheet></Timesheet>
            } else if (currentPath === "invoicenormalinfo") {
                return <InvoiceNormalInfo></InvoiceNormalInfo>
            } else if (currentPath === "invoicecreate") {
                return <InvoiceCreate></InvoiceCreate>
            } else if (currentPath === "matterlist") {
                return <MatterList></MatterList>
            } else if (currentPath === "dashboard") {
                return <Dashboard></Dashboard>
            } else if (currentPath === "casebalance") {
                return <CaseBalance></CaseBalance>
            } else if (currentPath === "caseinvoice") {
                return <CaseInvoice></CaseInvoice>
            } else if (currentPath === "smarttools") {
                return <SmartTools></SmartTools>
            } else if (currentPath === "toolestate") {
                return <ToolEstate></ToolEstate>
            } else if (currentPath === "invoiceadvanceinfo") {
                return <InvoiceAdvanceInfo></InvoiceAdvanceInfo>
            } else if (currentPath === "invoicelist") {
                return <InvoiceList></InvoiceList>
            } else if (currentPath === "referral") {
                return <ReferralList></ReferralList>
            } else if (currentPath === "editreferral") {
                return <ReferralEdit></ReferralEdit>
            } else if (currentPath === "tooltrademark") {
                return <ToolTrademark></ToolTrademark>
            } else if (currentPath === "revenue") {
                return <Revenue></Revenue>
            } else if (currentPath === "conflictStandardTask") {
                return <ConflictStandardTask></ConflictStandardTask>
            } else if (currentPath === "conflictTask") {
                return <ConflictTask></ConflictTask>
            } else if (currentPath === "conflictTaskInfo") {
                return <ConflictTaskInfo></ConflictTaskInfo>
            } else if (currentPath === "conflictReport") {
                return <ConflictReport></ConflictReport>
            } else if (currentPath === "conflictReportInfo") {
                return <ConflictReportInfo></ConflictReportInfo>
            }
        }
        const listItem = (item) => {
            if (item.subItem) {
                return <Fragment>
                    <ListItem button onClick={e => this.handleOpenItemClick(e, item)}>
                        <ListItemIcon>
                            {icons(item.index)}
                        </ListItemIcon>
                        <ListItemText primary={item.name} />
                        {(openItem === item.index) ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={(openItem === item.index)} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {item.subItem.map(obj => (
                                <Link style={{ color: '#212C31', textDecoration: 'none' }} to={obj.url} key={obj.index}>
                                    <ListItem
                                        className="subItem"
                                        button
                                        selected={selectedIndex === obj.index}
                                        onClick={event => this.handleListItemClick(event, obj.index)}
                                    >
                                        <ListItemText primary={obj.name} />
                                    </ListItem>
                                </Link>
                            ))}
                        </List>
                    </Collapse>
                </Fragment>
            } else {
                return <Link style={{ color: '#212C31', textDecoration: 'none' }} to={item.url} key={item.index}>
                    <ListItem
                        className="navItem"
                        button
                        selected={selectedIndex === item.index}
                        onClick={event => this.handleListItemClick(event, item.index)}
                    >
                        <ListItemIcon>
                            {icons(item.index)}
                        </ListItemIcon>
                        <ListItemText primary={item.name} />
                    </ListItem>
                </Link>
            }
        }
        return (
            <Fragment>
                <Root>
                    <AppBar className="appbar" position="fixed" color="default">
                        <Toolbar>
                            <div className="logo"></div>
                            <div className="f h h-r">
                                <IconButton className="icon" aria-label="Show 4 new mails" color="inherit">
                                    <Badge badgeContent={0} color="secondary">
                                        <MailIcon />
                                    </Badge>
                                </IconButton>
                                <IconButton className="icon" aria-label="Show 17 new notifications" color="inherit">
                                    <Badge badgeContent={0} color="secondary">
                                        <NotificationsIcon />
                                    </Badge>
                                </IconButton>
                                <IconButton
                                    className="icon"
                                    edge="end"
                                    aria-label="Account of current user"
                                    aria-controls={menuId}
                                    aria-haspopup="true"
                                    onClick={this.handleMenu}
                                    color="inherit"
                                >
                                    <AccountCircle />
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={open}
                                    onClose={this.handleClose}
                                >
                                    <MenuItem onClick={this.handleMyProfile}>My Profile</MenuItem>
                                    <MenuItem onClick={this.handleSettings}>Settings</MenuItem>
                                    <MenuItem onClick={this.handleSingOut}>Sign Out</MenuItem>
                                </Menu>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <Drawer className="drawer" variant="permanent">
                        <div className="toolbar"></div>
                        <div className="user c" onClick={this.handleMyProfile}>
                            <LetterAvatar name={userInfo.first_name + ' ' + userInfo.last_name} />
                            <div className="username">{userInfo.first_name} {userInfo.last_name}</div>
                            <div className="job">{userInfo.position ? userInfo.position : ""}</div>
                        </div>
                        <List component="nav">
                            {navData.map(item => (
                                <Fragment key={item.index}>
                                    {listItem(item)}
                                </Fragment>
                            ))}
                        </List>
                    </Drawer>
                    <main className="content">
                        <div className="toolbar"></div>
                        <div>
                            {currentPage()}
                        </div>
                    </main>
                    <AlertDialog
                        open={showAlert}
                        title="Warning"
                        content="Sign out?"
                        handleAlertYes={this.handleAlertYes}
                        handleAlertNo={this.handleAlertNo}
                    ></AlertDialog>
                </Root>
            </Fragment>
        );
    }
    componentDidMount() {
        userDao.getUserInfo((userInfo) => {
            globalData.userInfo = userInfo;
            this.setState(() => ({
                userInfo
            }));
        });
        let navData = [];
        let selectedIndex = this.getIndexByName();
        console.log(isRole(ROLES.admin))
        console.log(isRole(ROLES.deptManager))
        console.log(isRole(ROLES.team_leader))
        if (isRole(ROLES.admin)) {
            navData = [
                {
                    index: 0,
                    name: "Dashboard",
                    url: "/main/dashboard",
                },
                {
                    index: 1,
                    name: "Department",
                    url: "/main/department",
                }, {
                    index: 2,
                    name: "User",
                    url: "/main/user",
                }, {
                    index: 3,
                    url: '',
                    name: 'Client',
                    subItem: [
                        {
                            index: 31,
                            url: '/main/addclient',
                            name: 'Add Client'
                        }, {
                            index: 32,
                            url: '/main/clientlist',
                            name: 'Client List'
                        }, {
                            index: 33,
                            url: '/main/processinglist',
                            name: 'Processing List'
                        }
                    ]
                }, {
                    index: 4,
                    name: "Case",
                    url: "/main/case",
                },
                //  {
                //     index: 5,
                //     name: "Matter",
                //     url: "/main/matterlist",
                // },
                {
                    index: 6,
                    name: "Timesheet",
                    url: "/main/timesheet",
                }, {
                    index: 7,
                    url: '',
                    name: 'Billing',
                    subItem: [
                        {
                            index: 71,
                            url: '/main/invoicelist',
                            name: 'Invoice'
                        }, {
                            index: 72,
                            url: '/main/revenue',
                            name: 'Revenue'
                        }
                    ]
                }, {
                    index: 8,
                    url: '',
                    name: 'Bonus',
                    subItem: [
                        {
                            index: 81,
                            url: '/main/referral?tab_index=0&page_index=1&page_size=5',
                            name: 'Referral'
                        },
                        // {
                        //     index: 82,
                        //     url: '/main/others',
                        //     name: 'Others'
                        // }
                    ]
                }, {
                    index: 9,
                    url: '',
                    name: 'Conflict',
                    subItem: [
                        {
                            index: 91,
                            url: '/main/conflictStandardTask',
                            name: 'Standard Task'
                        },{
                            index: 92,
                            url: '/main/conflictTask',
                            name: 'Task'
                        }, {
                            index: 93,
                            url: '/main/conflictReport',
                            name: 'Report'
                        }
                    ]
                }, {
                    index: 10,
                    name: "Smart Tools",
                    url: "/main/smarttools",
                }
            ]
        } else if (isRole(ROLES.deptManager)) {
            navData = [
                {
                    index: 0,
                    name: "Dashboard",
                    url: "/main/dashboard",
                },
                {
                    index: 1,
                    name: "Team",
                    url: "/main/deptTeam",
                }, {
                    index: 2,
                    name: "Colleague",
                    url: "/main/user",
                }, {
                    index: 3,
                    url: '',
                    name: 'Client',
                    subItem: [
                        {
                            index: 31,
                            url: '/main/addclient',
                            name: 'Add Client'
                        }, {
                            index: 32,
                            url: '/main/clientlist',
                            name: 'Client List'
                        }, {
                            index: 33,
                            url: '/main/processinglist',
                            name: 'Processing List'
                        }
                    ]
                }, {
                    index: 4,
                    name: "Case",
                    url: "/main/case",
                },
                // {
                //     index: 5,
                //     name: "Matter",
                //     url: "/main/matterlist",
                // },
                {
                    index: 6,
                    name: "Timesheet",
                    url: "/main/timesheet",
                }, {
                    index: 7,
                    url: '',
                    name: 'Billing',
                    subItem: [
                        {
                            index: 71,
                            url: '/main/invoicelist',
                            name: 'Invoice'
                        }
                        , {
                            index: 72,
                            url: '/main/revenue',
                            name: 'Revenue'
                        }
                    ]
                }, {
                    index: 8,
                    url: '',
                    name: 'Bonus',
                    subItem: [
                        {
                            index: 81,
                            url: '/main/referral?tab_index=0&page_index=1&page_size=5',
                            name: 'Referral'
                        },
                        // {
                        //     index: 82,
                        //     url: '/main/others',
                        //     name: 'Others'
                        // }
                    ]
                }, {
                    index: 9,
                    url: '',
                    name: 'Conflict',
                    subItem: [
                        {
                            index: 92,
                            url: '/main/conflictTask',
                            name: 'Task'
                        }, {
                            index: 93,
                            url: '/main/conflictReport',
                            name: 'Report'
                        }
                    ]
                }, {
                    index: 10,
                    name: "Smart Tools",
                    url: "/main/smarttools",
                }
            ]
        } else if (isRole(ROLES.team_leader)) {
            navData = [
                {
                    index: 0,
                    name: "Dashboard",
                    url: "/main/dashboard",
                },
                {
                    index: 1,
                    name: "Team",
                    url: "/main/leaderteam",
                }, {
                    index: 2,
                    name: "Colleague",
                    url: "/main/user",
                }, {
                    index: 3,
                    url: '',
                    name: 'Client',
                    subItem: [
                        {
                            index: 31,
                            url: '/main/addclient',
                            name: 'Add Client'
                        }, {
                            index: 32,
                            url: '/main/clientlist',
                            name: 'Client List'
                        }, {
                            index: 33,
                            url: '/main/processinglist',
                            name: 'Processing List'
                        }
                    ]
                }, {
                    index: 4,
                    name: "Case",
                    url: "/main/case",
                },
                // {
                //     index: 5,
                //     name: "Matter",
                //     url: "/main/matterlist",
                // },
                {
                    index: 6,
                    name: "Timesheet",
                    url: "/main/timesheet",
                }, {
                    index: 7,
                    url: '',
                    name: 'Billing',
                    subItem: [
                        {
                            index: 71,
                            url: '/main/invoicelist',
                            name: 'Invoice'
                        }
                        // , {
                        //     index: 72,
                        //     url: '/main/billingstatistics',
                        //     name: 'Billing Statistics'
                        // }
                    ]
                }, {
                    index: 8,
                    url: '',
                    name: 'Bonus',
                    subItem: [
                        {
                            index: 81,
                            url: '/main/referral?tab_index=0&page_index=1&page_size=5',
                            name: 'Referral'
                        },
                        // {
                        //     index: 82,
                        //     url: '/main/others',
                        //     name: 'Others'
                        // }
                    ]
                }, {
                    index: 9,
                    url: '',
                    name: 'Conflict',
                    subItem: [
                        {
                            index: 92,
                            url: '/main/conflictTask',
                            name: 'Task'
                        }, {
                            index: 93,
                            url: '/main/conflictReport',
                            name: 'Report'
                        }
                    ]
                }, {
                    index: 10,
                    name: "Smart Tools",
                    url: "/main/smarttools",
                }
            ]
        } else {
            navData = [
                {
                    index: 0,
                    name: "Dashboard",
                    url: "/main/dashboard",
                },
                {
                    index: 1,
                    name: "Team",
                    url: "/main/staffteam",
                }, {
                    index: 2,
                    name: "Colleague",
                    url: "/main/user",
                }, {
                    index: 3,
                    url: '',
                    name: 'Client',
                    subItem: [
                        {
                            index: 31,
                            url: '/main/addclient',
                            name: 'Add Client'
                        }, {
                            index: 32,
                            url: '/main/clientlist',
                            name: 'Client List'
                        }, {
                            index: 33,
                            url: '/main/processinglist',
                            name: 'Processing List'
                        }
                    ]
                }, {
                    index: 4,
                    name: "Case",
                    url: "/main/case",
                },
                // {
                //     index: 5,
                //     name: "Matter",
                //     url: "/main/matterlist",
                // },
                {
                    index: 6,
                    name: "Timesheet",
                    url: "/main/timesheet",
                }, {
                    index: 7,
                    url: '',
                    name: 'Billing',
                    subItem: [
                        {
                            index: 71,
                            url: '/main/invoicelist',
                            name: 'Invoice'
                        }
                        // , {
                        //     index: 72,
                        //     url: '/main/billingstatistics',
                        //     name: 'Billing Statistics'
                        // }
                    ]
                }, {
                    index: 8,
                    url: '',
                    name: 'Bonus',
                    subItem: [
                        {
                            index: 81,
                            url: '/main/referral?tab_index=0&page_index=1&page_size=5',
                            name: 'Referral'
                        },
                        // {
                        //     index: 82,
                        //     url: '/main/others',
                        //     name: 'Others'
                        // }
                    ]
                }, {
                    index: 9,
                    url: '',
                    name: 'Conflict',
                    subItem: [
                        {
                            index: 92,
                            url: '/main/conflictTask',
                            name: 'Task'
                        }, {
                            index: 93,
                            url: '/main/conflictReport',
                            name: 'Report'
                        }
                    ]
                }, {
                    index: 10,
                    name: "Smart Tools",
                    url: "/main/smarttools",
                }
            ]
        }
        this.setState(() => ({
            navData,
            selectedIndex
        }))
        let isReload = localStorage.getItem('isReload');
        if (isReload === "1") {
            window.location.reload();
            localStorage.setItem('isReload', "0");
        }
        this.props.history.listen(() => {
            setTimeout(() => {
                let selectedIndex = this.getIndexByName();
                this.setState(() => ({
                    selectedIndex
                }))
            }, 250);
        })
    }
    handleChange(e) {
        const value = e.target.checked;
        this.setState(() => ({
            auth: value
        }));
    }
    handleMenu(e) {
        const value = e.currentTarget;
        this.setState(() => ({
            anchorEl: value,
            open: true
        }));
    }
    handleClose() {
        this.setState(() => ({
            open: false
        }));
    }
    handleMyProfile() {
        this.props.history.push({ pathname: '/main/myprofile' });
    }
    handleSettings() {
        this.props.history.push({ pathname: '/main/settings' });
    }
    handleSingOut() {
        this.setState(() => ({
            showAlert: true
        }));
    }
    handleListItemClick(e, index) {
        this.setState(() => ({
            selectedIndex: index
        }));
    }
    handleMenuClick() {
        this.setState(() => ({
            open_link: !this.state.open_link
        }))
    }
    handleOpenItemClick(e, item) {
        let index = item.index;
        let subItem = item.subItem;
        let openItem = 0;
        if (subItem) {
            if (index === prevItem) {
                prevItem = 0;
                openItem = 0;
            } else {
                prevItem = index;
                openItem = index;
            }
        } else {
            openItem = index;
        }
        this.setState(() => ({
            openItem
        }));
    }
    handleAlertYes() {
        this.props.history.push({ pathname: '/login' });
        localStorage.clear();
        this.setState(() => ({
            showAlert: false
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false
        }));
    }
    getIndexByName() {
        let pathName = this.props.location.pathname;
        let pathArr = pathName.split("/");
        let currentPath = pathArr[2];
        if (currentPath === "dashboard") {
            return 0;
        } else if (currentPath === "department" || currentPath === "deptTeam" || currentPath === "leaderteam" || currentPath === "staffteam") {
            return 1;
        } else if (currentPath === "user") {
            return 2;
        } else if (currentPath === "addclient") {
            this.setState(() => ({
                openItem: 3
            }));
            return 31;
        } else if (currentPath === "clientlist") {
            this.setState(() => ({
                openItem: 3
            }));
            return 32;
        } else if (currentPath === "processinglist") {
            this.setState(() => ({
                openItem: 3
            }));
            return 33;
        } else if (currentPath === "case" || currentPath === "casebalance" || currentPath === "caseinvoice") {
            return 4;
        } else if (currentPath === "matterlist") {
            return 5;
        } else if (currentPath === "timesheet") {
            return 6;
        } else if (currentPath === "invoicelist") {
            this.setState(() => ({
                openItem: 7
            }));
            return 71;
        } else if (currentPath === "revenue") {
            this.setState(() => ({
                openItem: 7
            }));
            return 72;
        } else if (currentPath === "refeeral" || currentPath === "editreferral") {
            this.setState(() => ({
                openItem: 8
            }));
            return 81;
        } else if (currentPath === "conflictStandardTask") {
            this.setState(() => ({
                openItem: 9
            }));
            return 91;
        } else if (currentPath === "conflictTask") {
            this.setState(() => ({
                openItem: 9
            }));
            return 92;
        } else if (currentPath === "conflictReport") {
            this.setState(() => ({
                openItem: 9
            }));
            return 93;
        } else if (currentPath === "smarttools" || currentPath === "toolestate") {
            return 10;
        }
    }
}

export default withRouter(Layout);